import { MouseEventHandler } from "react";

import {
  faEdit,
  faRotateRight,
  faToggleOff,
  faToggleOn,
  faTrashCan,
} from "@fortawesome/pro-regular-svg-icons";

import { RawCell } from "src/dataTable/RawCell";
import { IconButton } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";

type Props = {
  isActive: boolean;
  onRenameClick: MouseEventHandler;
  onRotateClick: MouseEventHandler;
  onToggleStatusClick: MouseEventHandler;
  onDeleteClick: MouseEventHandler;
};

export const OAuthClientActions: React.FC<Props> = ({
  isActive,
  onRenameClick,
  onRotateClick,
  onToggleStatusClick,
  onDeleteClick,
}) => {
  const actions = (
    <div className="flex items-center justify-end gap-x-2">
      <Tooltip placement="top" title="Rotate key" asChild>
        <IconButton
          dataLoc="oauth-client-rotate-key"
          icon={faRotateRight}
          size="xs"
          onClick={onRotateClick}
        />
      </Tooltip>
      <Tooltip placement="top" title="Rename" asChild>
        <IconButton
          dataLoc="oauth-client-rename"
          icon={faEdit}
          size="xs"
          onClick={onRenameClick}
        />
      </Tooltip>
      <Tooltip placement="top" title={isActive ? "Disable" : "Enable"} asChild>
        <IconButton
          dataLoc="oauth-client-toggle-status"
          icon={isActive ? faToggleOn : faToggleOff}
          size="xs"
          onClick={onToggleStatusClick}
        />
      </Tooltip>
      <Tooltip placement="top" title="Delete" asChild>
        <IconButton
          dataLoc="oauth-client-delete"
          icon={faTrashCan}
          size="xs"
          onClick={onDeleteClick}
        />
      </Tooltip>
    </div>
  );

  return (
    <RawCell
      cell={actions}
      classNameOverrides="min-h-[48px] invisible flex items-right justify-end group-hover:visible max-w-0"
    />
  );
};
